// extracted by mini-css-extract-plugin
export var accordion = "_di-0";
export var chevron = "_di-3";
export var closed = "_di-2";
export var content = "_di-4";
export var open = "_di-1";
export var rotate = "_di-5";